import * as React from 'react';
import { styled } from '@mui/material/styles';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { IconButton } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

export const InfoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}));

const InfoIcon = ({ id }) => {
    return (
        <InfoTooltip
            title={
                <FormattedMessage id={id} />
            }
            arrow>
            <IconButton>
                <InfoOutlinedIcon />
            </IconButton>
        </InfoTooltip>
    );
};

export default InfoIcon;